import React, { useState, useEffect } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import dayjs from "dayjs";
import { Link, NavLink } from "react-router-dom";
import {
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const ClientList = () => {
  const [businessType, setBusinessType] = useState("insurance");
  const [tableData, setTableData] = useState([]);
  const [deletionItem, setDeletionItem] = useState(null);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let endpoint = "";
        if (businessType === "insurance") {
          endpoint = "/api/getInsuranceRegistrations";
        } else if (businessType === "fitness") {
          endpoint = "/api/getFitnessRegistrations";
        } else if (businessType === "permit") {
          endpoint = "/api/getPermitRegistrations";
        } else if (businessType === "pollution") {
          endpoint = "/api/getPollutionRegistrations";
        } else if (businessType === "tax") {
          endpoint = "/api/getTaxRegistrations";
        }

        const response = await axiosInstance.get(endpoint);
        setTableData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [businessType]);

  const handleConfirmDelete = async () => {
    try {
      if (isNaN(deletionItem)) {
        console.error("Invalid itemId:", deletionItem);
        return; // Do not proceed with deletion if itemId is not a number
      }

      let endpoint = "";

      if (businessType === "insurance") {
        endpoint = `/api/deleteInsurenceItem/${deletionItem}`;
      } else if (businessType === "fitness") {
        endpoint = `/api/deleteFitnessItem/${deletionItem}`;
      } else if (businessType === "permit") {
        endpoint = `/api/deletePermitItem/${deletionItem}`;
      } else if (businessType === "pollution") {
        endpoint = `/api/deletePollutionItem/${deletionItem}`;
      } else if (businessType === "tax") {
        endpoint = `/api/deleteTaxItem/${deletionItem}`;
      }

      await axiosInstance.delete(endpoint);

      const updatedTableData = tableData.filter(
        (item) => item.id !== deletionItem
      );
      setTableData(updatedTableData);
      setDeletionItem(null);
      setDeleteSuccess(true);

      setTimeout(() => {
        setDeleteSuccess(false);
      }, 2000);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const handleDocumentDownload = (documentData, dataId) => {
    const byteArray = new Uint8Array(documentData.data);
    const blob = new Blob([byteArray], { type: "application/octet-stream" });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `document_${dataId}.pdf`); // Change the file extension if the document is of a different type
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleBusinessTypeChange = (event) => {
    setBusinessType(event.target.value);
  };

  const formattedDate = (date) => {
    if (!date) {
      return ""; // Return an empty string for blank dates
    }
    return dayjs(date).format("DD-MM-YYYY"); // Format the date as needed for non-blank dates
  };

  const handleCloseDialog = () => {
    setDeletionItem(null); // Reset deletionItem state if cancel is clicked
  };

  return (
    <>
      <Grid container item xs={12}>
        <Grid item xs={8}>
          <Typography variant="h5" align="left">
            Client Details
          </Typography>
        </Grid>
        {/* <Grid item xs={4} className="text-end">
          <EditIcon />
        </Grid> */}
      </Grid>

      <Grid container spacing={3}>
        <Grid container item xs={12} className="mt-3">
          <Grid item>
            <Typography variant="h6" align="left">
              Services Types
            </Typography>
          </Grid>
          <Grid item>
            <FormControl>
              <Select
                value={businessType}
                onChange={handleBusinessTypeChange}
                fullWidth
                size="small"
                className="ms-3"
              >
                <MenuItem value="insurance">Insurance</MenuItem>
                <MenuItem value="fitness">Fitness</MenuItem>
                <MenuItem value="permit">Permit</MenuItem>
                <MenuItem value="pollution">Pollution</MenuItem>
                <MenuItem value="tax">Tax</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {/* Define table headers based on business types */}
                  {businessType === "insurance" ? (
                    <>
                      <TableCell>Owner Name</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Guardian Name</TableCell>
                      <TableCell>Vehicle Number</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Registration Number</TableCell>
                      <TableCell>Registration Date</TableCell>
                      <TableCell>NCB</TableCell>
                      <TableCell>CD</TableCell>
                      <TableCell>Engine Number</TableCell>
                      <TableCell>Chassis Number</TableCell>
                      <TableCell>Od Premium</TableCell>
                      <TableCell>Net Premium</TableCell>
                      <TableCell>Final Premium</TableCell>
                      <TableCell>Policy Number</TableCell>
                      <TableCell>IDV Value</TableCell>
                      <TableCell>Mac Module</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Expire Date</TableCell>
                      <TableCell>Penality</TableCell>
                      {/* <TableCell>Document</TableCell> */}
                      <TableCell>Action</TableCell>
                    </>
                  ) : businessType === "fitness" ? (
                    <>
                      <TableCell>Owner Name</TableCell>
                      <TableCell>Guardian Name</TableCell>
                      <TableCell>Vehicleno</TableCell>
                      <TableCell>Engine Number</TableCell>
                      <TableCell>Chassis Number</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Expire Date</TableCell>
                      <TableCell>Vechile Number</TableCell>
                      <TableCell>Action</TableCell>
                    </>
                  ) : businessType === "permit" ? (
                    <>
                      <TableCell>Owner Name</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Guardian Name</TableCell>
                      <TableCell>Vehicle Number</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Permit Type</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Expire Date</TableCell>
                      <TableCell>Action</TableCell>
                    </>
                  ) : businessType === "pollution" ? (
                    <>
                      <TableCell>Owner Name</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Guardian Name</TableCell>
                      <TableCell>Vehicle Number</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Registration Number</TableCell>
                      <TableCell>Registration Date</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Expire Date</TableCell>
                      <TableCell>Pollution Type</TableCell>
                      <TableCell>Action</TableCell>
                    </>
                  ) : businessType === "tax" ? (
                    <>
                      <TableCell>Owner Name</TableCell>
                      <TableCell>Address</TableCell>
                      <TableCell>Guardian Name</TableCell>
                      <TableCell>Vehicle Number</TableCell>
                      <TableCell>Phone Number</TableCell>
                      <TableCell>Tax Type</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>Expire Date</TableCell>
                      <TableCell>Chassis Number</TableCell>

                      <TableCell>Action</TableCell>
                    </>
                  ) : (
                    <TableCell>No Data</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Check if tableData has data before mapping */}
                {Array.isArray(tableData) && tableData.length > 0 ? (
                  tableData.map((data, index) => (
                    <TableRow key={index}>
                      {businessType === "insurance" ? (
                        <>
                          <TableCell>
                            <NavLink to={`/dashboard/client-update/${data.id}`}>
                              {data.ownername}
                            </NavLink>
                          </TableCell>
                          <TableCell>{data.address}</TableCell>
                          <TableCell>{data.guardianname}</TableCell>
                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>{data.phoneno}</TableCell>
                          <TableCell>{data.registrationno}</TableCell>
                          <TableCell>
                            {formattedDate(data.registrationdate)}
                          </TableCell>
                          <TableCell>{data.ncb}</TableCell>
                          <TableCell>{data.cd}</TableCell>
                          <TableCell>{data.engineno}</TableCell>
                          <TableCell>{data.chassisno}</TableCell>
                          <TableCell>{data.odpremium}</TableCell>
                          <TableCell>{data.netpremium}</TableCell>
                          <TableCell>{data.finalpremium}</TableCell>
                          <TableCell>{data.policyno}</TableCell>
                          <TableCell>{data.idvvalue}</TableCell>

                          <TableCell>{data.macmodule}</TableCell>
                          <TableCell>{formattedDate(data.startdate)}</TableCell>
                          <TableCell>
                            {formattedDate(data.expiredate)}
                          </TableCell>
                          <TableCell>{data.penality}</TableCell>

                          {/* <TableCell>
                            {data.insurencedocument && (
                              <IconButton
                                aria-label="download"
                                onClick={() =>
                                  handleDocumentDownload(
                                    data.insurencedocument,
                                    data.id
                                  )
                                }
                              >
                                <CloudDownloadIcon />
                              </IconButton>
                            )}
                          </TableCell> */}
                          <TableCell>
                            <IconButton>
                              <DeleteIcon
                                onClick={() => setDeletionItem(data.id)}
                              />
                            </IconButton>
                            {/* Add edit functionality */}
                            <IconButton>
                              {data.id && (
                                <Link
                                  to={`/dashboard/client-update/${data.id}`}
                                >
                                  <EditIcon />
                                </Link>
                              )}
                            </IconButton>
                          </TableCell>
                        </>
                      ) : businessType === "fitness" ? (
                        <>
                          <TableCell>
                            <NavLink to={`/dashboard/fitness-update/${data.id}`}>
                              {data.ownername}
                            </NavLink>
                          </TableCell>
                          <TableCell>{data.guardianname}</TableCell>
                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>{data.engineno}</TableCell>
                          <TableCell>{data.chassisno}</TableCell>
                          <TableCell>{formattedDate(data.startdate)}</TableCell>
                          <TableCell>
                            {formattedDate(data.expiredate)}
                          </TableCell>

                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>
                            <IconButton size="small">
                              {data.id && (
                                <Link
                                  to={`/dashboard/fitness-update/${data.id}`}
                                >
                                  <EditIcon />
                                </Link>
                              )}
                            </IconButton>
                            <IconButton size="small">
                              <DeleteIcon
                                onClick={() => setDeletionItem(data.id)}
                              />
                            </IconButton>
                          </TableCell>
                        </>
                      ) : businessType === "permit" ? (
                        <>
                          <TableCell>
                            <NavLink to={`/dashboard/permit-update/${data.id}`}>
                              {data.ownername}
                            </NavLink>
                          </TableCell>
                          <TableCell>{data.address}</TableCell>
                          <TableCell>{data.guardianname}</TableCell>
                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>{data.phoneno}</TableCell>
                          <TableCell>{data.permittype}</TableCell>
                          <TableCell>{formattedDate(data.startdate)}</TableCell>
                          <TableCell>
                            {formattedDate(data.expiredate)}
                          </TableCell>

                          <TableCell>
                            <IconButton size="small">
                              {data.id && (
                                <Link
                                  to={`/dashboard/permit-update/${data.id}`}
                                >
                                  <EditIcon />
                                </Link>
                              )}
                            </IconButton>
                            <IconButton size="small">
                              <DeleteIcon
                                onClick={() => setDeletionItem(data.id)}
                              />
                            </IconButton>
                          </TableCell>
                        </>
                      ) : businessType === "pollution" ? (
                        <>
                          <TableCell>

                            <NavLink to={`/dashboard/polution-update/${data.id}`}>
                              {data.ownername}
                            </NavLink>
                          </TableCell>
                          <TableCell>{data.address}</TableCell>
                          <TableCell>{data.guardianname}</TableCell>
                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>{data.phoneno}</TableCell>
                          <TableCell>{data.registrationno}</TableCell>
                          <TableCell>
                            {formattedDate(data.registrationdate)}
                          </TableCell>
                          <TableCell>{formattedDate(data.startdate)}</TableCell>
                          <TableCell>
                            {formattedDate(data.expiredate)}
                          </TableCell>
                          <TableCell>{data.pollutiontype}</TableCell>
                          <TableCell>
                            <IconButton>
                              <DeleteIcon
                                onClick={() => setDeletionItem(data.id)}
                              />
                            </IconButton>
                            {/* Add edit functionality */}
                            <IconButton>
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                        </>
                      ) : businessType === "tax" ? (
                        <>
                          <TableCell>
                            <NavLink to={`/dashboard/tax-update/${data.id}`}>
                              {data.ownername}
                            </NavLink>
                          </TableCell>
                          <TableCell>{data.address}</TableCell>
                          <TableCell>{data.guardianname}</TableCell>
                          <TableCell>{data.vehicleno}</TableCell>
                          <TableCell>{data.phoneno}</TableCell>
                          <TableCell>{data.taxtype}</TableCell>
                          <TableCell>{formattedDate(data.startdate)}</TableCell>
                          <TableCell>
                            {formattedDate(data.expiredate)}
                          </TableCell>
                          <TableCell>chassisno</TableCell>
                          <TableCell>
                            <IconButton>
                              <DeleteIcon
                                onClick={() => setDeletionItem(data.id)}
                              />
                            </IconButton>
                            {/* Add edit functionality */}
                            <IconButton>
                              <EditIcon />
                            </IconButton>
                          </TableCell>
                        </>
                      ) : (
                        <TableCell>No Data</TableCell>
                      )}
                    </TableRow>
                  ))
                ) : (
                  // Render a single row indicating no data when tableData is empty
                  <TableRow>
                    <TableCell colSpan={3}>No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>

      <Dialog
        open={Boolean(deletionItem)}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      {/* Success Snackbar when item is deleted */}
      <Snackbar
        open={deleteSuccess}
        autoHideDuration={2000}
        onClose={() => setDeleteSuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setDeleteSuccess(false)}
          severity="success"
        >
          Item deleted successfully!
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default ClientList;
